"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var colorScaleDefault = ["#FFE000", "#FABC60", "#3A9679", "#11144C", "#A3F7BF", "#29A19C", "#435055", "#27323A"];
var _default = colorScaleDefault;
exports["default"] = _default;